import { FC, MouseEvent } from 'react';
import { DropdownButtonItem, DropdownButton } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { uuid } from 'utils';
import { useOffsiteCampaignEditorDispatch } from '../../../context/UseOffsiteCampaignEditorContext';
import { ISegment } from 'sections/offsite-campaigns/entities/offsiteCampaign';

export interface IProps {
  segmentId: string;
  segment: ISegment;
}
export const SegmentDropdown: FC<IProps> = props => {
  const { t } = useTranslation('campaigns');
  const dispatch = useOffsiteCampaignEditorDispatch();
  const onCloneClick = (event: MouseEvent) => {
    event.stopPropagation();
    const cloneSegment = JSON.parse(JSON.stringify(props.segment)) as ISegment;
    cloneSegment.id = uuid();

    if (cloneSegment.percentageSplits !== null && cloneSegment.percentageSplits !== undefined) {
      cloneSegment.percentageSplits.forEach(split => {
        split.id = uuid();
        // OFFSITE-3177 Generate a new split test ID for the cloned segment ONLY if the original had a split test ID
        if (cloneSegment.splitTestId) {
          cloneSegment.splitTestId = uuid();
        }
        if (split.cycles !== null && split.cycles !== undefined) {
          split.cycles.forEach(cycle => {
            cycle.id = uuid();
          });
        }
      });
    }

    dispatch({
      type: 'ADD_SEGMENT',
      payload: {
        segment: cloneSegment,
      },
    });
  };

  return (
    <DropdownButton variation="clean" icon="ellipsis-v" menuPlacement="right">
      <DropdownButtonItem onClick={onCloneClick}>
        {t('campaigns:offsiteEditor.segments.segmentDropdown.clone')}
      </DropdownButtonItem>
    </DropdownButton>
  );
};
